<template>
  <div class="lshf">
    <template>
       <h4 style="color: aliceblue;margin-top: -30px">
         历史回放

       </h4>
       <!-- <el-form  :model="endTime" :rules="rules" label-width="100px" style="margin-top: -40px;">
         <el-row>
           <el-col :span="12">
             <el-form-item  prop="dateTime"> -->
              <el-date-picker v-model="Time" prefix-icon="el-icon-date" type="datetimerange" style="margin-top: -30px;"
                start-placeholder="录像开始日期" end-placeholder="录像结束日期" size="small" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
             <!-- </el-form-item>
           </el-col>
         </el-row>
       </el-form> -->
     </template>

    <div class="u-myflex">
      <div style="min-height: 8.1rem" class="u-flex-1 u-myflex u-flexwrap video-div">
        <div id="video0" :style="{'width':width }">
          <div class="test-ellipsis video-title">窗口1</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera1.streamUrl || tempOpen"
              :data="camera1"
            ></video-ws-stream> -->
            <playback-flv v-if="camera0.streamUrl" :style="{ 'height': height + 'px','width':width }" :url="camera0.streamUrl" :playon="camera0.playon"></playback-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div v-if="camera0.streamUrl"><span style="float:left;">回放时段:{{tranNumber(camera0.startTime)}}-{{tranNumber(camera0.endTime)}}</span>
            <!-- <el-button class="el-icon-video-pause" type="primary" size='mini' @click="pausePlay(0,camera0.streamId)"/><el-button class="el-icon-video-play" type="primary" size='mini' @click="resumePlay(0,camera0.streamId)"/> -->
              <el-dropdown split-button type="primary" size="mini" @command="handleCommand">
                倍速
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(0,'0.25')">0.25倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(0,'0.5')">0.5倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(0,'1')">1倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(0,'2')">2倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(0,'4')">4倍速</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-slider v-model="value1" :max="max0" :format-tooltip="formatTooltip1" @change="sliderChange($event,camera0.streamId,0)" ></el-slider>
            </div>
          </div>
        </div>
        <div id="video1" v-if="!width">
          <div class="test-ellipsis video-title">窗口2</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera2.streamUrl || tempOpen"
              :data="camera2"
            ></video-ws-stream> -->
            <playback-flv v-if="camera1.streamUrl" height="300px" :url="camera1.streamUrl" ></playback-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div v-if="camera1.streamUrl"><span style="float:left;">回放时段:{{tranNumber(camera1.startTime)}}-{{tranNumber(camera1.endTime)}}</span>
            <!-- <el-button class="el-icon-video-pause" type="primary" size='mini' @click="pausePlay(1,camera1.streamId)"/><el-button class="el-icon-video-play" type="primary" size='mini' @click="resumePlay(1,camera1.streamId)"/> -->
              <el-dropdown split-button type="primary" size="mini" @command="handleCommand">
                倍速
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(1,'0.25')">0.25倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(1,'0.5')">0.5倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(1,'1')">1倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(1,'2')">2倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(1,'4')">4倍速</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-slider v-model="value2" :max="max1" :format-tooltip="formatTooltip2" @change="sliderChange($event,camera1.streamId,1)" ></el-slider>
            </div>
          </div>
        </div>
        <div id="video2" v-if="!width">
          <div class="test-ellipsis video-title">窗口3</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera3.streamUrl || tempOpen"
              :data="camera3"
            ></video-ws-stream> -->
            <playback-flv v-if="camera2.streamUrl" height="300px" :url="camera2.streamUrl" ></playback-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div v-if="camera2.streamUrl"><span style="float:left;">回放时段:{{tranNumber(camera2.startTime)}}-{{tranNumber(camera2.endTime)}}</span>
            <!-- <el-button class="el-icon-video-pause" type="primary" size='mini' @click="pausePlay(2,camera2.streamId)"/><el-button class="el-icon-video-play" type="primary" size='mini' @click="resumePlay(2,camera2.streamId)"/> -->
              <el-dropdown split-button type="primary" size="mini" @command="handleCommand">
                倍速
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(2,'0.25')">0.25倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(2,'0.5')">0.5倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(2,'1')">1倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(2,'2')">2倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(2,'4')">4倍速</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-slider v-model="value3" :max="max2" :format-tooltip="formatTooltip3" @change="sliderChange($event,camera2.streamId,2)" ></el-slider>
            </div>
          </div>
        </div>
        <div id="video3" v-if="!width">
          <div class="test-ellipsis video-title">窗口4</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera4.streamUrl || tempOpen"
              :data="camera4"
            ></video-ws-stream> -->
            <playback-flv v-if="camera3.streamUrl" height="300px" :url="camera3.streamUrl" ></playback-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div v-if="camera3.streamUrl"><span style="float:left;">回放时段:{{tranNumber(camera3.startTime)}}-{{tranNumber(camera3.endTime)}}</span>
            <!-- <el-button class="el-icon-video-pause" type="primary" size='mini' @click="pausePlay(3,camera3.streamId)"/><el-button class="el-icon-video-play" type="primary" size='mini' @click="resumePlay(3,camera3.streamId)"/> -->
              <el-dropdown split-button type="primary" size="mini" @command="handleCommand">
                倍速
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(3,'0.25')">0.25倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(3,'0.5')">0.5倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(3,'1')">1倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(3,'2')">2倍速</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(3,'4')">4倍速</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-slider v-model="value4" :max="max3" :format-tooltip="formatTooltip4" @change="sliderChange($event,camera3.streamId,3)" ></el-slider>
            </div>
          </div>
        </div>
        <p style="float:left; margin-top:10px;margin-bottom: 10px;">分屏窗口数: <el-button  type="primary" size='mini' @click="oneVideo">1</el-button>
                 <el-button  type="primary" size='mini' @click="fourVideo">4</el-button></p>
      </div>
      <div class="video-list">
        <div class="u-flex-2 u-position-relative">
          <el-table :data="mp4Path" stripe>
            <el-table-column label="历史回放">
              <template slot-scope="scope">
                <div class="u-myflex u-j-sb u-a-center">
                  <el-tooltip
                    :disabled="scope.row.path.length < 26"
                    :content="scope.row.path"
                    placement="top"
                    effect="light"
                  >
                    <a
                      href="javascript:;"
                      @click="showVideoBtn(scope.row.value, scope.row.path,scope.row.deviceId)"
                      style="margin-left: 10px"
                      :class="[
                        'u-line-1',
                        scope.row.value == videoBtnId ? 'u-color-primary' : '',
                      ]"
                      >{{ scope.row.path }}</a
                    >
                  </el-tooltip>
                  <el-select
                    @change="(index) => getRecordlist(scope.row.deviceId, index)"
                    style="width: 100px"
                    v-model="mp4Path[scope.row.value].videoValue"
                    placeholder="通道选择"
                    :key="selectKey"
                    size="mini"
                    v-if="channelOpen"
                  >
                    <el-option
                      v-for="item in scope.row.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="u-position-absolute u-t-10 u-r--20">
            <el-pagination
              @current-change="clickPage"
              layout="total,prev, pager, next"
              :total="total"
              :pager-count="5"
              :page-size="13"
            >
            </el-pagination>
          </div>

        </div>
        <!-- 历史列表 -->
        <el-table :data="mp4PathSuffix" stripe class="u-flex-1" :key="refreKey2" style="max-height: 700px;overflow: auto;">
          <el-table-column label="历史列表">
            <template slot-scope="scope">
              <div class="u-myflex u-j-sb u-a-center">
                <el-tooltip
                  :disabled="scope.row.path.length < 10"
                  :content="scope.row.path"
                  placement="top"
                  effect="light"
                >
                  <a
                    href="javascript:;"
                    @click="openVideo(scope.row.deviceId,scope.row.channelId,0,scope.row.startTime,scope.row.endTime)"
                    style="margin-left: 10px"
                    :class="[
                      'u-line-1',
                      scope.row.value == videoBtn_history ? 'u-color-primary' : '',
                    ]"
                    >{{ scope.row.path }}</a
                  >
                </el-tooltip>

                <el-select
                  @change="(index) => openVideo(scope.row.deviceId,scope.row.channelId,index,scope.row.startTime,scope.row.endTime)"
                  style="width: 100px"
                  v-model="mp4PathSuffix[scope.row.value].videoValue"
                  placeholder="请选择"
                  :key="selectKey"
                  size="mini"
                  v-if="videoNum"
                >
                  <el-option
                    v-for="item in scope.row.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="list-real">
          <h2>实时播放</h2>
          <div
            v-for="(item, index) in mp4Path"
            :key="index"
            class="video-name-list"
          >
            <div
              class="list-title test-ellipsis"
              @click="showVideoBtn('videobtn' + index, item.path)"
            >
              {{ realTitle(item.path) }}
            </div>
            <div class="video-btn" :id="'videobtn' + index">
              <div>
                <el-button
                  type="success"
                  round
                  size="mini"
                  @click="videoSet(0, item.path)"
                  >窗口1</el-button
                >
              </div>
              <div>
                <el-button
                  type="success"
                  round
                  size="mini"
                  @click="videoSet(1, item.path)"
                  >窗口2</el-button
                >
              </div>
              <div>
                <el-button
                  type="success"
                  round
                  size="mini"
                  @click="videoSet(2, item.path)"
                  >窗口3</el-button
                >
              </div>
              <div>
                <el-button
                  type="success"
                  round
                  size="mini"
                  @click="videoSet(3, item.path)"
                  >窗口4</el-button
                >
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="list-history">
          <h2>历史播放</h2>
          <div v-if="historyShow">
            <div
              v-for="(item, index) in mp4PathSuffix"
              :key="index"
              class="video-name-list"
            >
              <div
                class="list-title test-ellipsis"
                style="text-align: center"
                @click="historyvideoSet(item)"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import videoWsStream from "@/components/video-ws-stream.vue";
import config from "@/web.config.js";
import playbackFlv from "@/components/playback-flv.vue";
export default {
  components: { videoWsStream ,"playback-flv": playbackFlv},

  data() {
    const typeTime = {
      beginTime: this.$myPlug.timeFormat(
        new Date().getTime(),
        "yyyy-mm-dd 00:00:00"
      ),
      endTime: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd hh:MM:ss"),
    };
    return {
      Time: Object.values(typeTime),
      tempOpen: config.tempOpen,
      total: 0,
      camera0: {streamUrl:"",deviceId:"",channelId:"",streamId:"",playon:true,startTime:"",endTime:""},
      camera1: {streamUrl:"",deviceId:"",channelId:"",streamId:"",playon:true,startTime:"",endTime:""},
      camera2: {streamUrl:"",deviceId:"",channelId:"",streamId:"",playon:true,startTime:"",endTime:""},
      camera3: {streamUrl:"",deviceId:"",channelId:"",streamId:"",playon:true,startTime:"",endTime:""},
      streamRequestSeq: [0, 0, 0, 0],
      channelId: "",
      recordchannelId: "",
      baseUrl: config.cameraUrl,
      width:"",
      height:300,
      videoNum:true,
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      max0:100,
      max1:100,
      max2:100,
      max3:100,
      channelOpen:false,
      deviceListForm: {
        deviceType: "4",
        pageIndex: 1, //经常改，也不知道用哪个字段
        page: 1, //经常改，也不知道用哪个字段
        pageRow: 13,
        limit: 13,
      },
      refreKey: "a",
      refreKey2: "c",
      label: "",
      selectKey: "s",
      videoBtn_history: "",
      videoValue: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
        },
      ],
      videoAutoplay: false, //设置视频是否自动播放
      mp4Path: [
        { path: "东城翠峰路中段公交站", value: 0 },
        { path: "旗峰公园免费停车场", value: 1 },
        { path: "黄旗山公园-右侧绿道入口", value: 2 },
        { path: "黄旗山公园-登旗峰山顶转弯处", value: 3 },
      ],
      mp4PathSuffix: [],
      mp4PathSuffix_0: [
        { path: "2022-04-24", value: 0 },
        { path: "2022-04-25", value: 1 },
        { path: "2022-04-26", value: 2 },
      ],
      mp4PathSuffix_1: [
        { path: "2022-03-22", value: 0 },
        { path: "2022-01-25", value: 1 },
        { path: "2022-01-20", value: 2 },
      ],
      mp4PathSuffix_2: [
        { path: "2022-04-04", value: 0 },
        { path: "2022-04-15", value: 1 },
        { path: "2022-02-06", value: 2 },
      ],
      mp4PathSuffix_3: [
        { path: "2022-03-21", value: 0 },
        { path: "2022-04-15", value: 1 },
        { path: "2022-01-21", value: 2 },
      ],
      mp4PathSuffix_index: [],
      videoBtnId: null, //用来保存展开了按钮的列表项
      historyShow: false, //历史播放列表显隐
      videoPlay: [], //保存哪个摄像头在播放
      pathHistory: "",
      save_selectKey: [],
    };
  },
  methods: {
    changeSelect(index, mp4PthIndex) {
      // const save_index = this.save_selectKey.indexOf(index);
      // if (save_index > -1) {
      //   if (this.mp4Path[save_index].videoValue > -1) {
      //     this.videoSet(save_index, null);
      //   }
      //   this.save_selectKey[save_index] = -1;
      //   this.mp4Path[save_index].videoValue = "";
      // }

      this.save_selectKey[mp4PthIndex] = index;

      this.selectKey = "s" + new Date().getTime();
      this.videoSet(index, this.mp4Path[mp4PthIndex].path,this.mp4Path[mp4PthIndex].deviceId);
    },
    showVideoBtn(index, path ,deviceId) {
      // let node = document.getElementById(index);
      if (this.videoBtnId == index) {
        // node.className = 'video-btn';
        this.videoBtnId = null;
        this.historyShow = false;
        this.pathHistory = "";
      } else if (this.videoBtnId !== index && this.videoBtnId == null) {
        // node.className = 'video-btn video-btn-show';
        this.videoBtnId = index;
        this.historyShow = true;
        this.pathHistory = path;
      } else {
        // let node1 = document.getElementById(this.videoBtnId);
        // node1.className = 'video-btn';
        // node.className = 'video-btn video-btn-show';
        this.videoBtnId = index;
        this.historyShow = true;
        this.pathHistory = path;
      }
      this.label = path;
      //this.mp4PathSuffix_index = [];
      //let channelId = "";
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/device/query/devices/'+deviceId+'/channels?page=1&count=15',
      	timeout: 30000,
      	}).then(res=>{
        if (res.data) {
          if (!this.total) this.total = res.data.total;
          this.channelId = res.data.list[0].deviceId;
          // res.data.list.forEach((element, key) => {
          //   this.mp4PathSuffix_index.push({
          //     path: element.channelId,
          //     value: key,
          //   });
          // });
          let n = [];
          res.data.list.forEach((element, key) => {
            n.push({
              lable: element.channelId,
              value: element.channelId,
              deviceId: deviceId
            });
          });
          let list = this.mp4Path.map((item, key) => {
            if(key == index)
            item.options = n;
            return item;
          });
          this.$set(this, "mp4Path", list);
          this.getRecordlist(deviceId,this.channelId)
        }
      });

      // let list = this.mp4PathSuffix_index.map((item, key) => {
      // //let list = this["mp4PathSuffix_" + index].map((item, key) => {
      //   item.options = [
      //     {
      //       value: "0",
      //       label: "窗口1",
      //     },
      //     {
      //       value: "1",
      //       label: "窗口2",
      //     },
      //     {
      //       value: "2",
      //       label: "窗口3",
      //     },
      //     {
      //       value: "3",
      //       label: "窗口4",
      //     },
      //   ];
      //   return item;
      // });
      // this.$set(this, "mp4PathSuffix", list);
      // console.log(this.mp4PathSuffix)
      // this.refreKey2 = "c" + new Date().getTime();
    },
    oneVideo(){
      this.height = 600;
      this.width = "100%";
      this.videoNum = false;
    },
    fourVideo(){
      this.height = 300;
      this.width = "";
      this.videoNum = true;
    },
    tranNumber(time) {
      let n = time.substr(-8)
      return n
    },
    formatTooltip1(val) {
      let time = new Date(this.camera0.startTime);
      let secondes = time.getSeconds();
      time.setSeconds(secondes+val);
      return time.toLocaleString();
    },
    formatTooltip2(val) {
      let time = new Date(this.camera1.startTime);
      let secondes = time.getSeconds();
      time.setSeconds(secondes+val);
      return time.toLocaleString();
    },
    formatTooltip3(val) {
      let time = new Date(this.camera2.startTime);
      let secondes = time.getSeconds();
      time.setSeconds(secondes+val);
      return time.toLocaleString();
    },
    formatTooltip4(val) {
      let time = new Date(this.camera3.startTime);
      let secondes = time.getSeconds();
      time.setSeconds(secondes+val);
      return time.toLocaleString();
    },
    beforeHandleCommand(index,command){   //index我这里是遍历的角标，即你需要传递的额外参数
        return {
                  'index': index,
                  'command':command
        }
    },
    handleCommand(command) {
        this.speedPlay(this["camera"+command.index].streamId,command.command,command.index)
      },
    videoSet(index, name,deviceId, set = true) {
      this.save_selectKey.push(index);
      //this.openVideo(this.mp4Path[index], index);
      console.log(name)
      //this.openVideo(deviceId,name,index);
      console.log('播放')
      if (set) {
        this.$set(this.videoPlay, index, name);
      } else {
        this.$set(this.videoPlay, index, this.pathHistory);
      }
    },
    historyvideoSet(item) {
      this.videoBtn_history = item.value;
      let num = this.videoPlay.indexOf(this.pathHistory);
      if (num > -1) {
        if (item.path !== "2022-04-26") {
          let path = this.pathHistory + "_" + item.path;
          this.videoSet(num, path, false);
        } else {
          this.videoSet(num, this.pathHistory, false);
        }
      } else {
        this.$message.error("请先实时播放该摄像头");
      }
    },
    //openVideo(info, index) {
      /* if (process.env.NODE_ENV === "production") {
        this.$http
          .GET_wsAddress({
            params: {
              paramsID: info.deviceID,
            },
          })
          .then((res) => {});
      } else {
        this.$axios("-camera/domeCamera/getWsAddress/88").then((res) => {
          if (res.data) {
            // this["camera" + (index + 1)] = res.data;
            this["camera" + (index + 1)] = Object.assign(
              {},
              this["camera" + (index + 1)],
              res.data
            );
            this.refreKey = "c" + new Date().getTime();
          }
        });
      } */
    //},
    sliderChange(seekTime,streamId,index) {
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/playback/seek/'+streamId+'/'+seekTime,
      	//headers:this.headers,
      	timeout: 30000,
      	}).then(res=>{
          if(res.code == 0){
            this.$message.success('拖放播放成功!')
            this["camera"+index].playon = true;
          }
          else{
            this.$message.error(res.msg);
          }
      	},err=>{
        console.log("error:"+err);
        this.openVideo(this["camera"+index].deviceId,this["camera"+index].channelId,index,this["camera"+index].startTime,this["camera"+index].endTime);
        setTimeout(() => {
          this.sliderChange2(seekTime,this["camera"+index].streamId,index);
        }, 2000);
    })
    },
    sliderChange2(seekTime,streamId,index) {
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/playback/seek/'+streamId+'/'+seekTime,
      	//headers:this.headers,
      	timeout: 30000,
      	}).then(res=>{
          if(res.code == 0){
            this["camera"+index].playon = true;
          }
          else{
            this.$message.error(res.msg);
          }
      	},err=>{
        })
    },
    speedPlay(streamId,speed,index){
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/playback/speed/'+streamId+'/'+speed,
      	//headers:this.headers,
      	timeout: 30000,
      	}).then(res=>{
          if(res.code == 0){
            this.$message.success(speed+'倍速播放中')
          }
          else{
            this.$message.error(res.msg);
          }
      	},err=>{
        console.log("error:"+err);
        this.openVideo(this["camera"+index].deviceId,this["camera"+index].channelId,index,this["camera"+index].startTime,this["camera"+index].endTime);
    })
    },
    pausePlay(index,streamId){
      this["camera"+index].playon = false;
      // this.$axios({
      // 	method: 'get',
      // 	url: this.baseUrl+'/api/playback/pause/'+streamId,
      // 	//headers:this.headers,
      // 	timeout: 30000,
      // 	}).then(res=>{
      //     if(res.code == 0){
      //       this.$message.success("回放暂停成功!")
      //       this["camera"+index].playon = false;
      //     }
      //     else{
      //       this.$message.error(res.msg);
      //     }
      // 	})
    },
    resumePlay(index,streamId){
      this["camera"+index].playon = true;
      // this.$axios({
      // 	method: 'get',
      // 	url: this.baseUrl+'/api/playback/resume/'+streamId,
      // 	//headers:this.headers,
      // 	timeout: 30000,
      // 	}).then(res=>{
      //     if(res.code == 0){
      //       this.$message.success("回放恢复成功!")
      //       this["camera"+index].playon = true;
      //     }
      //     else{
      //       this.$message.error(res.msg);
      //     }
      // 	})
    },
    openVideo(deviceId,channelId,index,startTime,endTime){
      const requestId = (this.streamRequestSeq[index] || 0) + 1;
      this.$set(this.streamRequestSeq, index, requestId);
      const camera = this["camera" + index];
      camera.streamUrl = "";
      camera.deviceId = deviceId;
      camera.channelId = channelId;
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/playback/start/'+deviceId+'/'+channelId+'?startTime='+startTime+'&endTime='+endTime,
      	//headers:this.headers,
      	timeout: 30000,
      	}).then(res=>{
          if (this.streamRequestSeq[index] !== requestId
              || camera.deviceId !== deviceId
              || camera.channelId !== channelId) {
            return;
          }
          if(res.code == 0){
          camera.streamUrl = res.data.https_flv.indexOf('39.184.153.92')!=-1?res.data.https_flv.replace('39.184.153.92','huagongyq.dingpod.cn'):res.data.https_flv;
          // this["camera"+index].streamUrl = res.data.https_flv;
          camera.streamId = res.data.stream;
          camera.startTime = startTime;
          camera.endTime = endTime;
          let date1=new Date(startTime);  //开始时间
          let date2=new Date(endTime);    //结束时间
          this["max"+index] = parseInt(date2 - date1) / 1000;//两个时间相差的秒数
          }
          else{
            this.$message.error(res.msg);
          }
      	})
    },
    clickPage(index) {
      this.deviceListForm.pageIndex = this.deviceListForm.page = index;
      this.getDeviceList();
    },
    getRecordlist(deviceId,channelId){
      // let startTime = this.beginTime;
      // let endTime = this.endTime;
      console.log(this.Time)
      if(this.Time == "" || this.Time == null){
        this.$message.error("请先选择查询录像时间!");
      }else{
      let startTime = this.Time[0];
      let endTime = this.Time[1];
      this.recordchannelId = channelId;
      this.mp4PathSuffix_index = [];

      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/gb_record/query/'+deviceId+'/'+channelId+'?startTime='+startTime+'&endTime='+endTime,
      	//url: url,
        timeout: 30000,
      	}).then(res=>{
          if (res.data) {
            if (!this.total) this.total = res.data.total;
            res.data.recordList.forEach((element, key) => {
              this.mp4PathSuffix_index.push({
                path: element.startTime,
                value: key,
                deviceId: deviceId,
                channelId: this.recordchannelId,
                startTime: element.startTime,
                endTime: element.endTime
              });
            });
          }
          let list = this.mp4PathSuffix_index.map((item, key) => {
          //let list = this["mp4PathSuffix_" + index].map((item, key) => {
            item.options = [
              {
                value: "0",
                label: "窗口1",
              },
              {
                value: "1",
                label: "窗口2",
              },
              {
                value: "2",
                label: "窗口3",
              },
              {
                value: "3",
                label: "窗口4",
              },
            ];
            return item;
          });
          this.$set(this, "mp4PathSuffix", list);
          this.refreKey2 = "c" + new Date().getTime();
      	})
        }
    },
    getDeviceList() {
      this.mp4Path = [];
      this.mp4PathSuffix = [];
      //this.$http.POST_deviceList(this.deviceListForm).then((res) => {
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/device/query/devices?page='+this.deviceListForm.page+'&count=13',
      	timeout: 30000,
      	}).then(res=>{
        if (res.data) {
          if (!this.total) this.total = res.data.total;
          res.data.list.forEach((element, key) => {
            this.mp4Path.push({
              ...element,
              path: element.name || '未命名设备',
              value: key,
              videoValue: "",
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getDeviceList();
    // setTimeout(() => {
    //   this.openVideo(this.mp4Path[0], 0);
    // }, 2000);
  },
};
</script>

<style lang="scss">
.lshf {
  .el-table,
  .el-table__expanded-cell,
  .el-table tr {
    background: #091f38 !important;
  }
  .el-table th {
    background: #115599 !important;
  }
  .el-input.el-input--suffix {
    input {
      background-color: rgb(71, 154, 175);
    }
  }
  .el-pager li:hover {
    color: #0f0;
  }
  .el-table__cell {
    a {
      color: #fff !important;
    }
  }
  .el-pagination {
    button {
      background-color: transparent;
    }
  }
}
</style>
<style lang="scss" scoped>
.test-ellipsis {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
.video-div {
  color: #fff;
  font-size: 0.2rem;
  width: 63.5%;
  > div {
    border: 1px #054b76 solid;
    padding: 5px;
    width: 50%;
    text-align: center;
    .my-video {
      border: 1px #054b76 solid;
    }
    .video-title {
      border: none;
      padding: 3px 0 5px;
      font-weight: bold;
    }
  }
}
.video-list {
  width: 36.5%;
  height: 100%;
  overflow: auto;
  background: #115599;
  overflow-y: auto;
  padding: 10px 0;
  display: flex;
  h2 {
    text-align: center;
    color: #fff;
  }
  span {
    color: #fff;
  }
  .list-real {
    flex: 2;
    border-right: 1px solid rgb(158, 158, 158);
  }
  .list-history {
    flex: 1;
    border-left: 1px solid rgb(158, 158, 158);
  }
}
.video-name-list {
  width: 100%;
  color: #fff;
  padding: 0 10px;
  cursor: pointer;
  .list-title {
    width: 100%;
    height: 0.4rem;
    font-size: 0.25rem;
    line-height: 0.4rem;
    display: inline-flex;
  }

  .video-btn {
    display: none;
    padding: 5px;
    .el-button--mini {
      font-size: 14px;
      // width:60%;
    }
    > div {
      flex: 1;
      // text-align: center;
    }
  }
  .video-btn-show {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mngm/lshf.vue